import { render, staticRenderFns } from "./IssueSourceTableCell.vue?vue&type=template&id=44d9be04&scoped=true"
import script from "./IssueSourceTableCell.vue?vue&type=script&lang=js"
export * from "./IssueSourceTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueSourceTableCell.vue?vue&type=style&index=0&id=44d9be04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d9be04",
  null
  
)

export default component.exports